
import { Component, Vue, Prop } from "vue-property-decorator";
import store from "@shared/core/store";

@Component
export default class CustomerImage extends Vue {
  @Prop({ required: true, type: Object }) customer!: any;
  @Prop({ required: false, type: Number }) playersLength!: any;
  @Prop({ required: false, type: Number }) index!: any;
  @Prop({ required: false, type: Boolean }) showName!: any;
  @Prop({ required: false, type: Boolean }) showLevel!: any;

  private get isDarkMode() {
    return store.state.settings.DarkMode === true || this.$route.name === 'index';
  }

  private get customerFirstLetters() {
    const fullName = this.customer.name || "";
    const nameParts = fullName
      .split(" ")
      .filter(Boolean)
      .slice(0, 2);
    return nameParts.map((n) => n.charAt(0).toUpperCase()).join("");
  }

  getImageType(logo: string) {
    if (logo !== undefined && logo !== "" && logo !== null) {
      return store.state.settings.Uploads + "/" + logo;
    }
  }

  getNamePlayer(player: any) {
    if (player.customerId === -1) {
      return this.$t("Free Place");
    }
    return player.name.split(" ")[0];
  }
}
